"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupplyMeterInfo = void 0;
function getSupplyMeterInfo(data, fuel, index) {
    if (index === void 0) { index = 0; }
    return data[fuel][index] || null;
}
exports.getSupplyMeterInfo = getSupplyMeterInfo;
